// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_bootstrap_dist_js_bootstrap_esm_js"], function() { return __webpack_require__("./frontend/src/frontend.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
